export default __webpack_public_path__ + "static/media/slider_cover.4f9794e5.svg";